import { render, staticRenderFns } from "./batchAudit.vue?vue&type=template&id=554726d0&scoped=true&"
import script from "./batchAudit.vue?vue&type=script&lang=js&"
export * from "./batchAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554726d0",
  null
  
)

export default component.exports